import { atom } from "jotai";

export const isLoadingAtom = atom(false);
export const selectedCoursesAtom = atom([]);
export const courseAtom = atom({
  courseName: "",
  description: "",
  learnLang: "",
  forLang: "",
});

export const isCourseCreatorAtom = atom(false);

export const isCourseMemberAtom = atom(false);

export const newCourseAtom = atom("");

export const joinCourseDialogOpenAtom = atom(false);

export const handleClickCourseAtom = atom(
  null,
  (get, set, courseId, enabled) => {
    const current = get(selectedCoursesAtom);
    if (enabled) {
      set(selectedCoursesAtom, [...current, courseId]);
    } else {
      set(
        selectedCoursesAtom,
        current.filter((id) => id !== courseId),
      );
    }
  },
);
